import React from 'react';

function AudioPlayer({base64String, extension}) {

    let audioDataUri;
    let type;

    switch (extension) {
        case 'mp3':
            audioDataUri = `data:audio/mp3;base64,${base64String}`;
            type = 'audio/mp3';
            break;
        case 'wav':
            audioDataUri = `data:audio/wav;base64,${base64String}`;
            type = 'audio/wav';
            break;
        default:
            audioDataUri = `data:audio/wav;base64,${base64String}`;
            type = 'audio/wav';
            break;
    }


    return (
        <audio
            controls
            style={{
                height: '30px',
                maxWidth: '100%',
            }}
        >
            <source
                src={audioDataUri}
                type={type}
            />
            Your browser does not support the audio element.
        </audio>
    );
}

export default AudioPlayer;